"use client";

import { toast as sonnerToast, Toaster } from "sonner";

// Re-export Sonner's Toaster component
export { Toaster };

// Create a wrapper for the existing toast API
interface ToastOptions {
  type?: "success" | "error" | "warning" | "info";
  title: string;
  description?: string;
}

export function showToast({
  type = "success",
  title,
  description,
}: ToastOptions) {
  switch (type) {
    case "success":
      sonnerToast.success(title, {
        description,
      });
      break;
    case "error":
      sonnerToast.error(title, {
        description,
      });
      break;
    case "warning":
      sonnerToast.warning(title, {
        description,
      });
      break;
    case "info":
      sonnerToast.info(title, {
        description,
      });
      break;
  }
}

// Create a hook that matches the existing API
export function useToast() {
  return {
    showToast,
    toast: showToast, // Backward compatibility
    hideToast: () => {
      // Sonner handles auto-dismiss, but we can add manual dismiss if needed
      sonnerToast.dismiss();
    },
  };
}

// Legacy provider for backward compatibility
export function ToastProvider({ children }: { children: React.ReactNode }) {
  return (
    <>
      {children}
      <Toaster position="top-right" richColors closeButton duration={5000} />
    </>
  );
}
